<div class="d-flex flex-column justify-content-center" style="text-shadow: 2px 0px 10px black;">
    <h3 class="display-3 font-weight-bold my-7 text-white">
     {{ title }}
    </h3>
    <p class="font-size-lg text-white">
      {{ shortdesc }}
    </p>
  </div>
